import { isBlankText, isBlock, isBr, isElement, isText } from "../helpers";

const collapseWhitespace = (node: Node) => {
  node.childNodes.forEach((child) => {
    if (isText(child)) child.data = child.data.replace(/\s+/g, " ");
    else if (isElement(child)) collapseWhitespace(child);
  });
};

const tidy = (node: Node) => {
  const nodes = Array.from(node.childNodes);
  const isJunk = (child: Node) => isBr(child) || isBlankText(child);

  let start = 0;
  let end = nodes.length - 1;
  while (start <= end && isJunk(nodes[start])) nodes[start++].remove();
  while (end >= start && isJunk(nodes[end])) nodes[end--].remove();

  let afterBr = false;
  for (let i = start; i <= end; i++) {
    const child = nodes[i];
    if (isBr(child)) {
      if (afterBr) child.remove();
      afterBr = true;
    } else if (isBlankText(child)) {
      if (afterBr) child.remove();
    } else {
      afterBr = false;
    }
  }

  const kept = nodes.filter((child) => child.parentNode);
  const isEdge = (child: Node | undefined) => !child || isBr(child) || isBlock(child);
  kept.forEach((child, i) => {
    if (!isText(child)) return;
    let value = child.data;
    if (isEdge(kept[i - 1])) value = value.replace(/^ +/, "");
    if (isEdge(kept[i + 1])) value = value.replace(/ +$/, "");
    if (value) child.data = value;
    else child.remove();
  });

  kept.forEach((child) => {
    if (isBlock(child)) tidy(child);
  });
};

const cleanNode = <T extends Node>(node: T): T => {
  node.normalize();
  collapseWhitespace(node);
  tidy(node);
  return node;
};

export { cleanNode };
